import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import { SnackbarProvider } from "notistack";
import { ContextProvider } from "./Context/UserContext";
import { CartContextProvider } from "./Context/CartContext";
import { WishlistProvider } from "./Context/WishlistContext";

ReactDOM.render(
  <BrowserRouter>
    <ScrollToTop />
    <ContextProvider>
      <CartContextProvider>
        <WishlistProvider>
          <SnackbarProvider maxSnack={3}>
            <App />
          </SnackbarProvider>
        </WishlistProvider>
      </CartContextProvider>
    </ContextProvider>
  </BrowserRouter>,

  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
